var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,6.2c-0.6-0.7-1.2-1.2-2-1.7c-1.7,5.9-6.3,10.5-12.2,12.2c0.5,0.7,1,1.4,1.7,2 C12.4,17.3,17.3,12.4,18.7,6.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,7.1c-1.7,6-6.4,10.7-12.3,12.3c1.4,1,3.1,1.5,5,1.5c4.9,0,8.9-4,8.9-8.9v0C21,10.2,20.4,8.5,19.4,7.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9,4.1c-1.2-0.6-2.5-0.9-3.9-0.9h0c-4.9,0-8.9,4-8.9,8.9c0,1.4,0.3,2.7,0.9,3.8C9.9,14.4,14.4,9.9,15.9,4.1 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.fc174a08.svg";
export { ForwardRef as ReactComponent };